import { render } from "./TheOrganisationsList.vue?vue&type=template&id=db384cbe"
import script from "./TheOrganisationsList.vue?vue&type=script&lang=js"
export * from "./TheOrganisationsList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__